export function TypingIndicator() {
  return (
    <div className="flex items-center gap-[10px] self-stretch">
      <div className="flex gap-[5px]">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-[8px] w-[8px] rounded-full bg-[#909090] animate-bounce"
            style={{
              animationDelay: `${i * 150}ms`,
              animationDuration: "600ms",
            }}
          />
        ))}
      </div>
    </div>
  );
}